




















import Vue from "vue";
export default Vue.extend({
  props: ["note"],
  data: () => ({
    showEditIcon: false,
  }),
  methods: {
    toggleEditIcon() {
      this.showEditIcon = !this.showEditIcon;
    },
    viewNote(){
        this.$store.dispatch('global/setShowNoteDialog', true)
        this.$store.dispatch('global/setSelectedNote', this.note)
    }
  },
});
